import React, { useEffect } from 'react';

function FAQsPage({ onBack }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="faqs-page">
      {/* Top Navigation Bar */}
      <div className="faqs-top-bar">
        <div className="faqs-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="faqs-title-text">FAQs</div>
        <div className="faqs-spacer"></div>
      </div>

      {/* Content Area */}
      <div className="faqs-content">
        <div className="faqs-heading">common problem</div>

        {/* Section 1: Deposit */}
        <div className="faqs-section">
          <div className="faqs-section-number">1. Deposit</div>
          <ul className="faqs-list">
            <li>Due to the large amount of information on the platform, users should contact customer service to confirm and review the merchant's payment account information before each deposit.</li>
            <li>After the deposit is successful, the user must present the receipt of successful transfer so that the online customer service can handle the deposit for the user.</li>
            <li>In order to make an immediate deposit, the payee name and transfer amount must match the designated merchant payment account details.</li>
            <li>If unresolved problems arise during the recharge process, please contact online customer service immediately.</li>
            <li>If users have any questions, please contact online customer service for consultation!</li>
          </ul>
        </div>

        {/* Section 2: About cooperative merchant data */}
        <div className="faqs-section">
          <div className="faqs-section-number">2. About cooperative merchant data</div>
          <ul className="faqs-list">
            <li>Product data volume is adjusted based on market conditions.</li>
            <li>Data is randomly distributed based on the total balance of the user's account.</li>
            <li>The higher the total balance of the user account, the larger the data volume and the higher the income.</li>
            <li>If you are worried that the amount of merged data will be too large to bear, don't save too much and start optimizing.</li>
          </ul>
        </div>

        {/* Section 3: Cancel */}
        <div className="faqs-section">
          <div className="faqs-section-number">3. Cancel</div>
          <ul className="faqs-list">
            <li>Withdrawal time is from 09:30 to 21:30 daily.</li>
          </ul>
        </div>

        {/* Section 4: Platform user mode */}
        <div className="faqs-section">
          <div className="faqs-section-number">4. Platform user mode</div>
          <ul className="faqs-list">
            <li>Users can receive additional rewards by inviting new users to become platform users. The reward is 15% of the total daily reward of the referrer.</li>
          </ul>
        </div>

        {/* Section 5: Business hours */}
        <div className="faqs-section">
          <div className="faqs-section-number">5. Business hours</div>
          <ul className="faqs-list">
            <li>Users can start data advertising during daily business hours from 09:30-21:30.</li>
          </ul>
        </div>

        {/* Note Section */}
        <div className="faqs-note">
          <strong>Note:</strong> If you need further explanation, please click on the platform to contact online customer service!
        </div>
      </div>
    </div>
  );
}

export default FAQsPage;

